import { useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { LABEL_PRESET_CODES, type LabelPresetCode } from '@eombor/contracts';
import { Button, Input, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { Select } from '../../../shared/ui/Select.js';
import type { LabelSizeState } from '../model/label-size.js';

const presetLabel = (preset: LabelPresetCode): string => t(`warehouse.labelPreset${preset}`);

export interface LabelSizeFieldsProps {
  state: LabelSizeState;
  /**
   * Chap tomonda turadigan matn — masalan «Tanlangan: 3 ta katak».
   *
   * IXTIYORIY va bu ataylab. Mahsulot etiketkasi oynasida pastda
   * partiyalar ro'yxati turadi va son o'sha ro'yxatning takrori
   * bo'lardi — tepada ikkita deyarli bir xil satr chiqardi. Katak
   * oynasida esa ro'yxat yo'q: u yerda son YAGONA ma'lumot va usiz
   * nechta etiketka bosilishi umuman ko'rinmasdi.
   */
  summary?: string;
}

/**
 * O'LCHAM TANLOVI — YOPIQ turadi.
 *
 * Rulon omborga bir marta olinadi va yiliga bir marta almashadi, etiketka
 * esa kuniga bosiladi. Tanlov ro'yxati oynaning yarmini egallab, har
 * bosishda javob berilishi kerakdek ko'rinardi — aslida unga yilda bir
 * marta tegiladi. Endi u tugma ortida, tugmaning o'zi esa joriy o'lchamni
 * aytib turadi.
 *
 * O'lcham noto'g'ri bo'lsa bo'lim MAJBURAN ochiladi: aks holda bosish
 * tugmasi o'chib turardi va sababi yopiq qolardi.
 */
export const LabelSizeFields = ({ state, summary }: LabelSizeFieldsProps) => {
  const [open, setOpen] = useState(false);
  const shown = open || state.sizeMissing;

  return (
    <>
      <div
        className={cn(
          'flex flex-wrap items-center gap-2',
          summary === undefined ? 'justify-end' : 'justify-between',
        )}
      >
        {summary === undefined ? null : <p className="text-sm text-text-muted">{summary}</p>}

        <Button
          variant="ghost"
          size="sm"
          aria-expanded={shown}
          onClick={() => setOpen((current) => !current)}
        >
          <SlidersHorizontal size={14} aria-hidden />
          {t('warehouse.labelSizeToggle', { size: presetLabel(state.preset) })}
        </Button>
      </div>

      {!shown ? null : (
        <div
          className={cn(
            'border-border bg-surface-2 flex flex-col gap-3',
            'rounded-[var(--radius-sm)] border p-3',
          )}
        >
          <Select
            label={t('warehouse.labelPresetLabel')}
            value={state.preset}
            options={LABEL_PRESET_CODES.map((code) => ({ value: code, label: presetLabel(code) }))}
            onChange={(event) => state.choosePreset(event.target.value as LabelPresetCode)}
            hint={t('warehouse.labelSizeHint')}
          />

          {state.preset === 'CUSTOM' ? (
            <div className="flex gap-3">
              <Input
                label={t('warehouse.labelSizeWidth')}
                type="number"
                inputMode="numeric"
                value={state.size.widthMm}
                onChange={(event) => state.changeSize({ widthMm: event.target.value })}
              />
              <Input
                label={t('warehouse.labelSizeHeight')}
                type="number"
                inputMode="numeric"
                value={state.size.heightMm}
                onChange={(event) => state.changeSize({ heightMm: event.target.value })}
              />
              {/*
                Qog'oz baland bo'lsa bitta kodga shuncha joy kerak emas —
                ikkiga bo'linsa rulon ikki barobar uzoqqa yetadi.
              */}
              <Select
                label={t('warehouse.labelPerSheet')}
                value={String(state.size.perSheet)}
                options={[
                  { value: '1', label: t('warehouse.labelPerSheet1') },
                  { value: '2', label: t('warehouse.labelPerSheet2') },
                ]}
                onChange={(event) =>
                  state.changeSize({ perSheet: event.target.value === '2' ? 2 : 1 })
                }
              />
            </div>
          ) : null}
        </div>
      )}

      {state.sizeMissing ? (
        <p role="alert" className="text-sm text-warn">
          {t('warehouse.labelSizeInvalid')}
        </p>
      ) : null}
    </>
  );
};
